"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcClient = exports.ERR_CODE_PROTOCOL = void 0;
const types = __importStar(require("."));
const address_1 = require("../address");
const rpc_client_1 = require("../api_v2/rpc-client");
const errors = __importStar(require("../errors"));
const msg = __importStar(require("./msg"));
exports.ERR_CODE_PROTOCOL = -33000;
class JsonRpcClient {
    constructor(endpoint) {
        this._rpcClient = new rpc_client_1.RpcClient(endpoint);
    }
    async call(method, params) {
        try {
            if (typeof method === "string") {
                return await this._rpcClient.call(method, params);
            }
            return await this._rpcClient.call(method);
        }
        catch (error) {
            if (!(error instanceof rpc_client_1.RpcError) || error.code > exports.ERR_CODE_PROTOCOL)
                throw error;
            try {
                const raw = JSON.parse(error.data);
                return Promise.reject(new errors.Error(raw));
            }
            catch (_) {
                throw error;
            }
        }
    }
    async typedCall(method, params, inType, outType) {
        const res = await this.call(method, new inType(params).asObject());
        return "fromObject" in outType ? outType.fromObject(res) : new outType(res);
    }
    async typedCall2(method, params, inType, outType) {
        const res = (await this.call(method, new inType(params).asObject()));
        return "fromObject" in outType
            ? res.map((x) => outType.fromObject(x))
            : res.map((x) => new outType(x));
    }
    consensusStatus(opts = {}) {
        return this.typedCall("consensus-status", opts, msg.ConsensusStatusRequest, types.ConsensusStatus);
    }
    networkStatus(opts = {}) {
        return this.typedCall("network-status", opts, msg.NetworkStatusRequest, types.NetworkStatus);
    }
    // metrics(opts: types.MetricsOptions = {}): Promise<types.Metrics> {
    //   return this.typedCall('metrics', opts, msg.MetricsRequest, types.Metrics);
    // }
    submit(envelope, opts = {}) {
        return this.typedCall2("submit", { envelope, ...opts }, msg.SubmitRequest, types.Submission);
    }
    validate(envelope, opts = {}) {
        return this.typedCall2("validate", { envelope, ...opts }, msg.ValidateRequest, types.Submission);
    }
    faucet(account, opts = {}) {
        return this.typedCall("faucet", { account, ...opts }, msg.FaucetRequest, types.Submission);
    }
    query(scope, query = { queryType: "default" }) {
        if (scope instanceof address_1.TxID)
            scope = scope.asUrl();
        return this.typedCall("query", { scope, query }, msg.QueryRequest, types.Record);
    }
}
exports.JsonRpcClient = JsonRpcClient;
//# sourceMappingURL=client.js.map